import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import initApp from '../../lib/load/initApp';

var AssetPreloader = /*#__PURE__*/function (_Component) {
  _inherits(AssetPreloader, _Component);

  var _super = _createSuper(AssetPreloader);

  function AssetPreloader() {
    var _this;

    _classCallCheck(this, AssetPreloader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.hasCalledInitApp = false;
    return _this;
  }

  _createClass(AssetPreloader, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.props.load.assets.processed.length == 0) {
                  this.props.setAssetReferenceCount(this.props.images.length);
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var responses;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.props.load.assets.processed.length == this.props.images.length && this.hasCalledInitApp === false)) {
                  _context2.next = 16;
                  break;
                }

                if (!this.props.token.token) {
                  _context2.next = 15;
                  break;
                }

                this.hasCalledInitApp = true;
                _context2.prev = 3;
                _context2.next = 6;
                return initApp.bind(this)();

              case 6:
                responses = _context2.sent;
                this.props.setInitAppResponse(responses.initAppRes);
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](3);
                console.error(_context2.t0);

              case 13:
                _context2.next = 16;
                break;

              case 15:
                this.props.setInitAppResponse(-1);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 10]]);
      }));

      function componentDidUpdate() {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          images = _this$props.images,
          setInitAssetsLoaded = _this$props.setInitAssetsLoaded,
          markAssetLoaded = _this$props.markAssetLoaded,
          load = _this$props.load;
      var percentLoaded = Math.round(this.props.load.assets.processed.length / images.length * 100);
      if (!load.initAssetsLoaded && percentLoaded === 100) setInitAssetsLoaded(true);
      return this.props.render({
        processedAssetsAmount: this.props.load && this.props.load.assets.processed.length,
        totalAssetsAmount: images.length,
        images: images,
        markAssetLoaded: markAssetLoaded,
        setInitAssetsLoaded: setInitAssetsLoaded,
        percentLoaded: percentLoaded < 100 ? percentLoaded : 99
      });
    }
  }]);

  return AssetPreloader;
}(Component);

AssetPreloader.path = '';
export default AssetPreloader;